import React, { memo } from 'react';

const ChartCard = memo(({ title, icon, children, headerClass }) => (
    <div className="chart-card">
      <div className={`chart-header ${headerClass || ''}`}>
        <div className="chart-header-title">
          {icon}
          <h4 className="chart-title">
            {title}
          </h4>
        </div>
      </div>
      <div className="chart-body">
        {children}
      </div>
    </div>
  ));

export default ChartCard;